<div class="unsupported">
  <div>
    <p [innerHTML]="'UNSUPPORTED.DESCRIPTION' | t">
      UMMA 홈페이지는 <strong>크롬 브라우저</strong>에 최적화되어 있습니다.
    </p>
  </div>
  <div>
    @if (deviceOs === 'Android') {
      <a href="https://play.google.com/store/apps/details?id=com.android.chrome" target="_blank"
        ><img src="../../../../../assets/images/ico_chrome.svg" alt="" />
        <span [innerHTML]="'UNSUPPORTED.LINK' | t">크롬 브라우저 설치 하기</span></a
      >
    }
    @if (deviceOs === 'iOS') {
      <a href="https://apps.apple.com/kr/app/google-chrome/id535886823" target="_blank"
        ><img src="../../../../../assets/images/ico_chrome.svg" alt="" />
        <span [innerHTML]="'UNSUPPORTED.LINK' | t">크롬 브라우저 설치 하기</span></a
      >
    }
  </div>
</div>
